<template>
  <div>
    <div class="o-modal">
      <div class="o-modal__holder">
        <slot />
      </div>
    </div>
    <div class="o-modal__overlay" @click="$emit('onHide')"></div>
  </div>
</template>

<script>
export default {
  name: "OQModal",
};
</script>

<style scoped lang="scss"></style>
